import { render, staticRenderFns } from "./ListarMicrositios.vue?vue&type=template&id=01c9a048&"
import script from "./ListarMicrositios.vue?vue&type=script&lang=js&"
export * from "./ListarMicrositios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports